module.exports = __webpack_public_path__ + "static/media/xinzhao.0546ede2.png";